module.exports = __webpack_public_path__ + "static/media/IMG_2251.8cf8b132.jpg";